'use strict';

/*
 * Defines the currently valid build targets for the app.
 *
 * Allows for conditional branching logic based on expected run environment.
 *
 */
export const ANDROID_BUILD = '@@build-target/ANDROID';
export const IOS_BUILD = '@@build-target/IOS';
export const WEB_BUILD = '@@build-target/WEB';

export function isAndroidBuild() {
  return process.env.BUILD_TARGET === ANDROID_BUILD;
}

export function isIosBuild() {
  return process.env.BUILD_TARGET === IOS_BUILD;
}

export function isCordovaBuild() {
  return isAndroidBuild() || isIosBuild();
}

export function isWebBuild() {
  return process.env.BUILD_TARGET === WEB_BUILD;
}



// WEBPACK FOOTER //
// ./src/js/config/constants/build-target.js